if (!customElements.get('hh-compare')) {
  customElements.define(
    'hh-compare',
    class HhCompare extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('.hh-compare__slider');
        this.range = this.querySelector('.hh-compare__range');
        if (!this.slider || !this.range) return;

        this.range.addEventListener('input', () => {
          this.stopNudge();
          this.set(Number(this.range.value));
        });
        this.set(Number(this.range.value));

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.nudge();
          },
          { threshold: 0.6 }
        );
        this.observer.observe(this.slider);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.stopNudge();
      }

      set(value) {
        this.slider.style.setProperty('--pos', `${value}%`);
        this.slider.dataset.near = value < 12 ? 'start' : value > 88 ? 'end' : '';
      }

      // A gentle left-right sweep on first view so people notice it's draggable.
      nudge() {
        const keyframes = [50, 30, 70, 50];
        const segment = 650;
        const start = performance.now();
        const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

        const step = (now) => {
          const elapsed = now - start;
          const index = Math.min(Math.floor(elapsed / segment), keyframes.length - 2);
          const t = Math.min((elapsed - index * segment) / segment, 1);
          const value = keyframes[index] + (keyframes[index + 1] - keyframes[index]) * ease(t);
          this.range.value = value;
          this.set(value);
          if (elapsed < segment * (keyframes.length - 1)) this.frame = requestAnimationFrame(step);
        };
        this.frame = requestAnimationFrame(step);
      }

      stopNudge() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }
  );
}
